export default __webpack_public_path__ + "static/media/rakhi9.888436b7.jpeg";